/* eslint-disable import/prefer-default-export */
const THOUSAND_SEPARATOR = ".";
const DECIMAL_SEPARATOR = ",";

const isStringOrNumber = (n) => typeof n === "string" || typeof n === "number";
const isValidNumber = (n) => !Number.isNaN(parseInt(n, 10));
const isFloat = (n) =>
  n.toString().includes(THOUSAND_SEPARATOR) ||
  n.toString().includes(DECIMAL_SEPARATOR);

// Función segura sin regex vulnerable
const addThousandSeparators = (numStr) => {
  const parts = numStr.split(DECIMAL_SEPARATOR);
  const integerPart = parts[0];
  const decimalPart = parts[1];

  // Agregar separadores de miles de derecha a izquierda
  let formatted = "";
  for (let i = integerPart.length - 1, count = 0; i >= 0; i--, count++) {
    if (count > 0 && count % 3 === 0) {
      formatted = THOUSAND_SEPARATOR + formatted;
    }
    formatted = integerPart[i] + formatted;
  }

  return decimalPart
    ? `${formatted}${DECIMAL_SEPARATOR}${decimalPart}`
    : formatted;
};

const _formatInt = (amount) => {
  const normalized = amount
    .toString()
    .replace(THOUSAND_SEPARATOR, DECIMAL_SEPARATOR);
  const rounded = parseFloat(normalized).toFixed();
  return addThousandSeparators(rounded);
};

const _formatFloat = (amount) => {
  const normalized = amount
    .toString()
    .replace(THOUSAND_SEPARATOR, DECIMAL_SEPARATOR);
  return addThousandSeparators(normalized);
};

/* istanbul ignore next */
const _processValue = (amount) => {
  let result = 0;

  if (isStringOrNumber(amount) && isValidNumber(amount))
    result = isFloat(amount) ? _formatFloat(amount) : _formatInt(amount);

  return result;
};

export const toCurrencyFormat = (amount, noSymbol = false) =>
  `${noSymbol ? "" : "$ "}${_processValue(amount)}`;
